import React, { useState } from "react";
import "./RegistrarOffice.css";
import Navbar from "../../components/Homepage/Navbar/Navbar";
import Footer from "../../components/Homepage/Footer/Footer";
import { Link } from "react-router-dom";

const RegistrarOffice = () => {
    const [activeTab, setActiveTab] = useState("registrar");

    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    return (
        <>
            <Navbar />

            <section className="reg-office-page">
                <div className="reg-office-container">
                    <h1 className="reg-office-title">Office of the Registrar</h1>
                    <p className="reg-office-subtitle">
                        Administrative & Academic Coordination
                    </p>

                    {/* Mobile Toggle */}
                    <button
                        className="reg-mobile-sidebar-toggle"
                        onClick={() => setIsSidebarOpen(!isSidebarOpen)}
                    >
                        {isSidebarOpen ? "✕ Close Menu" : "☰ Sections"}
                    </button>

                    <div className="reg-layout">
                        {/* Sidebar */}
                        <aside className={`reg-sidebar ${isSidebarOpen ? "reg-sidebar-open" : ""}`}>
                            <div className="reg-sidebar-header">
                                <h3 >Quick Links</h3>
                            </div>

                            <div className="reg-sidebar-nav">
                                {[
                                    ["registrar", "Registrar Admin"],
                                    ["establishment", "Establishment Section"],
                                    ["finance", "Finance Section"],
                                    ["development", "Development Section"],
                                    ["engineering", "Engineering Section"],
                                ].map(([key, label]) => (
                                    <button
                                        key={key}
                                        className={`reg-nav-item ${activeTab === key ? "reg-nav-item-active" : ""}`}
                                        onClick={() => {
                                            setActiveTab(key);
                                            setIsSidebarOpen(false);
                                        }}
                                    >
                                        {label}
                                    </button>
                                ))}
                            </div>
                        </aside>

                        {/* ================= CONTENT ================= */}
                        <main className="reg-main">
                            {activeTab === "registrar" && (
                                <>
                                    {/* Registrar Profile Card */}
                                    <div className="reg-card">
                                        <img
                                            src="/person/registrar-Vijay.JPG"
                                            alt="Registrar"
                                        />

                                        <div className="reg-info">
                                            <h2>Prof. B. Vijaya Kumar Naidu</h2>
                                            <p className="designation">Registrar</p>
                                            <p className="university">
                                                Rayalaseema University, Kurnool
                                            </p>

                                            <Link
                                                to="/administration/registrar"
                                                className="reg-btn"
                                            >
                                                View Full Profile
                                            </Link>
                                        </div>
                                    </div>

                                    {/* Registrar Message */}
                                    <div className="rukdept-message">
                                        <h3 className="rukdept-message-title">
                                            Message from the Registrar
                                        </h3>

                                        <p>
                                            The Registrar plays a vital role in ensuring the smooth and
                                            effective functioning of the University administration.
                                            At Rayalaseema University, the Registrar’s office works
                                            continuously to uphold academic integrity, transparency,
                                            efficiency and compliance with statutory frameworks.
                                        </p>

                                        <p>
                                            With a strong commitment towards institutional excellence,
                                            the Registrar’s office coordinates academic processes,
                                            examinations, statutory bodies and administrative services
                                            for the benefit of students, faculty and stakeholders.
                                        </p>
                                    </div>

                                    {/* Key Highlights */}
                                    <div className="rukdept-highlights">
                                        <div className="rukdept-highlights-title">
                                            Key Responsibilities of the Registrar
                                        </div>

                                        <ul className="rukdept-highlights-list">
                                            <li>Overall supervision of University administration</li>
                                            <li>Custodian of statutory records and official documents</li>
                                            <li>Coordination of Academic Council and Executive Council</li>
                                            <li>Monitoring of admissions, examinations and results</li>
                                            <li>Implementation of University Acts and Ordinances</li>
                                            <li>Establishment and service matters of staff</li>
                                            <li>Liaison with UGC, APSCHE and Government bodies</li>
                                            <li>Ensuring institutional compliance and governance</li>
                                        </ul>
                                    </div>
                                </>
                            )}


                            {activeTab === "establishment" && (
                                <div className="reg-section">
                                    <h2>Establishment Section</h2>

                                    <p>
                                        The Establishment Section is responsible for managing all human resource
                                        and service-related matters of the University. It ensures smooth
                                        functioning of faculty and staff administration in accordance with
                                        University statutes, Government regulations, and UGC norms.
                                    </p>

                                    <p>
                                        This section plays a key role in recruitment, promotions, confirmations,
                                        disciplinary proceedings, and retirement benefits. It maintains personal
                                        files, service registers, and official records of all teaching and
                                        non-teaching employees.
                                    </p>

                                    {/* Key Highlights */}
                                    <div className="reg-highlights">
                                        <h3>Key Highlights</h3>
                                        <ul>
                                            <li>Recruitment of teaching and non-teaching staff</li>
                                            <li>Promotions, increments and career advancement schemes</li>
                                            <li>Leave management and service records</li>
                                            <li>Pension, gratuity and retirement benefits</li>
                                            <li>Disciplinary cases and service regulations</li>
                                            <li>Maintenance of employee database and HR systems</li>
                                        </ul>
                                    </div>

                                    {/* Staff Table */}
                                    <div className="reg-table-wrapper">
                                        <h3 className="reg-table-title">
                                            Establishment Section – Staff Details
                                        </h3>

                                        <table className="reg-staff-table">
                                            <thead>
                                                <tr>
                                                    <th>S.No</th>
                                                    <th>Name of the Employee</th>
                                                    <th>Designation</th>
                                                    <th>Section</th>
                                                    <th>Cell Number</th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                <tr>
                                                    <td>1</td>
                                                    <td>Dr. S. Venkateswarlu</td>
                                                    <td>In-charge Head</td>
                                                    <td>Establishment Section</td>
                                                    <td>9491945995</td>
                                                </tr>

                                                <tr>
                                                    <td>2</td>
                                                    <td>K. Sudhakar</td>
                                                    <td>Senior Assistant</td>
                                                    <td>Establishment Section</td>
                                                    <td>9704041058</td>
                                                </tr>

                                                <tr>
                                                    <td>3</td>
                                                    <td>U. Chandrakala</td>
                                                    <td>Junior Assistant</td>
                                                    <td>Establishment Section</td>
                                                    <td>9052751546</td>
                                                </tr>

                                                <tr>
                                                    <td>4</td>
                                                    <td>P. Sunkanna</td>
                                                    <td>Office Assistant</td>
                                                    <td>Establishment Section</td>
                                                    <td>9885589579</td>
                                                </tr>

                                                <tr>
                                                    <td>5</td>
                                                    <td>S. Babaiah</td>
                                                    <td>Office Subordinate</td>
                                                    <td>Establishment Section</td>
                                                    <td>9182455816</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            )}


                          {activeTab === "finance" && (
  <div className="reg-section">
    <h2>Finance Section</h2>

    <p>
      The Finance Section manages the financial planning, budgeting, and
      accounting of the University. It ensures that all financial transactions
      are carried out in a transparent and accountable manner as per Government
      and audit regulations.
    </p>

    <p>
      This section handles salary payments, grants, scholarships, procurement,
      internal audits, and external funding received from UGC, State Government,
      and other agencies.
    </p>

    {/* ================= STAFF TABLE ================= */}
    <div className="engg-table-wrapper">
      <h3 className="engg-table-title">Finance Section – Staff Details</h3>

      <table className="engg-staff-table">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Name</th>
            <th>Designation</th>
            <th>Section</th>
            <th>Phone</th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td>1</td>
            <td>A. Devi</td>
            <td>Office Assistant</td>
            <td>Finance Section</td>
            <td>8897179175</td>
          </tr>

          <tr>
            <td>2</td>
            <td>B. Anuradha</td>
            <td>Office Assistant</td>
            <td>Engineering College</td>
            <td>8985290649</td>
          </tr>
        </tbody>
      </table>
    </div>

    {/* ================= HIGHLIGHTS ================= */}
    <ul className="reg-highlights-list">
      <h2>Key Highlights</h2>
      <li>Preparation of annual budgets and financial reports</li>
      <li>Salary disbursement and payroll management</li>
      <li>Audit and compliance with statutory bodies</li>
      <li>Management of grants and research funds</li>
      <li>Scholarship and fellowship payments</li>
      <li>Procurement and tender financial processing</li>
    </ul>
  </div>
)}

                            {activeTab === "development" && (
                                <div className="reg-section">
                                    <h2>Development Section</h2>
                                    <p>
                                        The Development Section focuses on the overall physical growth and
                                        infrastructural planning of the University. It coordinates with various
                                        government departments and funding agencies for campus expansion and
                                        modernization.
                                    </p>
                                    <p>
                                        This section oversees construction projects, renovation works,
                                        landscaping, and implementation of development schemes under UGC, RUSA,
                                        and State Government initiatives.
                                    </p>

                                    <ul className="reg-highlights-list">
                                        <h2>Key Highlights</h2>
                                        <li>Planning and execution of new buildings</li>
                                        <li>Campus infrastructure development</li>
                                        <li>Project monitoring and progress reporting</li>
                                        <li>Coordination with architects and contractors</li>
                                        <li>Utilization of development grants</li>
                                        <li>Green campus and sustainability initiatives</li>
                                    </ul>
                                </div>
                            )}


                           <div className="engg-table-wrapper">
  <h3 className="engg-table-title">Engineering Section – Staff Details</h3>

  <table className="engg-staff-table">
    <thead>
      <tr>
        <th>S.No</th>
        <th>Name</th>
        <th>Designation</th>
        <th>Section</th>
        <th>Phone</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>1</td>
        <td>G. Vinod Kumar</td>
        <td>Coordinator</td>
        <td>Engineering Section</td>
        <td>9036298825</td>
      </tr>
      <tr>
        <td>2</td>
        <td>P. Narasappa</td>
        <td>Assistant Engineer</td>
        <td>Engineering Section</td>
        <td>9160417886</td>
      </tr>
      <tr>
        <td>3</td>
        <td>Y. Chiranjeevi Babu</td>
        <td>Work Inspector (Civil)</td>
        <td>Engineering Section</td>
        <td>9849264335</td>
      </tr>
      <tr>
        <td>4</td>
        <td>Vidyadharani S Siva Raju</td>
        <td>Work Inspector (Electrical)</td>
        <td>Engineering Section</td>
        <td>9566866879</td>
      </tr>
      <tr>
        <td>5</td>
        <td>S. Ismail</td>
        <td>Plumber</td>
        <td>Engineering Section</td>
        <td>9885469311</td>
      </tr>
      <tr>
        <td>6</td>
        <td>C. Rama Basi Reddy</td>
        <td>Electrician</td>
        <td>Engineering Section</td>
        <td>9494217742</td>
      </tr>
      <tr>
        <td>7</td>
        <td>V. Ramesh</td>
        <td>Electrician</td>
        <td>Engineering Section</td>
        <td>8106150744</td>
      </tr>
      <tr>
        <td>8</td>
        <td>B. Shaiksha Vali</td>
        <td>Electrician</td>
        <td>Engineering Section</td>
        <td>9703590950</td>
      </tr>
    </tbody>
  </table>
</div>


                        </main>
                    </div>
                </div>
            </section>

            <Footer />
        </>
    );
};

export default RegistrarOffice;
